module.exports = __webpack_public_path__ + "images/store_case_study/biciamore-pic1_66b196ed5610f27356a2b9f704f418e4.jpg";